
<template>
  <div class="mt-2">
    <v-card>
      <OperationalScreen_QuadrantToolbar
        :componentId="properties.componentId"
        :headers="headers"
        :title="properties.tag"
        :toolBarOptions="false"
      />
      <div v-if="!$store.getters.getEnlargedQuadrant">
        <div class="text-xs-center">
          <v-dialog
            v-model="datePickerDialog"
            width="500"
          >
            <v-card>
              <v-card-title
                class="headline grey lighten-2"
                primary-title
              >
                {{$translate('CHOOSE_DATE')}}
              </v-card-title>
              <v-date-picker
                :allowed-dates="allowedCalendarDates"
                :events="allowedCalendarDates"
                v-model="chosenDate"
                full-width
                no-title
                style="width:100%"
              ></v-date-picker>
              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  round
                  @click="getPlanBoard(chosenEvent)"
                >
                  {{$translate('ORDER')}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <v-layout class="toolBarTwo" align-start justify-start row wrap>
          <v-flex xs6>
            <v-select
              single-line
              v-if="noEvent === false"
              class="compact-form"
              :label="$translate('EVENT')"
              v-model="preEvent"
              :items="eventList"
              item-text="Name"
              return-object
              item-value="EventId"
              @change="openEventIndex"
            ></v-select>
            <v-select
              v-else
              :label="$translate('NO_EVENT_AVAILABLE')"
              :disabled="noEvent === true"
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
              single-line
              v-if="noEvent === false"
              class="compact-form"
              :label="$translate('EVENT_DATE_RANGE')"
              v-model="dateRangeSelection"
              :items="['Today','7 days ahead',' 1 month ahead', 'Free choice']"
              @change="triggerGetPlanBoard"
            ></v-select>
          </v-flex>
          <v-flex v-if="preEvent.Type === 'OrderEvent'" xs6>
            <v-select
              single-line
              v-if="noEvent == false"
              class="compact-form"
              :label="$translate('CHOOSE_AN_OPTION')"
              v-model="deliveryOrTakeAway"
              :items="['Delivery','TakeAway']"
              @change="triggerGetPlanBoard"
            ></v-select>
          </v-flex>
          <v-flex class="bottomRow" v-if="preEvent.Type === 'Rental'" xs6>
            <v-select
              single-line
              v-if="noEvent === false"
              class="compact-form"
              :label="$translate('EVENT_PRODUCT')"
              v-model="eventOrProducts"
              :items="['Event','Products']"
              @change="triggerGetProducts"
            ></v-select>
          </v-flex>
          <v-flex class="bottomRow" v-if="preEvent.Type === 'Rental' && eventOrProducts === 'Products'" xs6>
            <v-select
              single-line
              v-if="noEvent === false"
              class="compact-form"
              :label="$translate('EVENT_MESSAGE_SELECT_PRODUCT')"
              item-value="Id"
              item-text="Name"
              v-model="selectedProduct"
              :items="products"
              @change="triggerGetPlanBoard"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-card class="responseData">
          <v-flex xs12 v-if="emptyPlanboard">
            <v-layout align-space-around justify-space-around row fill-height>
              <v-icon justify-space-around disabled color="primary" style="font-size: 100px;">ballot</v-icon>
            </v-layout>
          </v-flex>
          <v-layout v-else justify-center>
            <v-flex xs12 d-flex>
              <v-card class="scrollbarCalendar elevation-0 transparent">
                <v-card v-for="(item, index) of planBoard.PlanBoard" :key="index">
                  <v-layout justify-center row wrap>
                    <v-card class="elevation-0 transparent calendarDate">
                      <h2 class="pa-1">{{item.Date}}</h2>
                    </v-card>
                  </v-layout>
                  <template v-for="(innerItem, innerIndex) of item.TimeSlots">
                    <v-hover :key="innerIndex">
                      <v-card @click="triggerSlotMessage(innerItem)" style="text-align:left"
                              color="grey"
                              class="timeslotsCards"
                              slot-scope="{ hover }"
                              :class="`elevation-${hover ? 5 : 2} lighten-${hover ? 3 : 2}`">
                        <v-layout row>
                          <v-flex xs3>
                            <v-card class="elevation-0 transparent">
                              <h4 v-if="innerItem.hasOwnProperty('Type')">{{innerItem.Time}} ({{innerItem.Type}})</h4>
                              <h4 v-else>{{innerItem.Time}}</h4>
                            </v-card>
                          </v-flex>
                          <v-flex xs8>
                            <v-layout justify-left align-left column>
                              <p class="smallerSpace">{{$translate('CAP_FREE_EVENT_CAP')}}<b>{{innerItem.FreeEventCapacity}}/{{planBoard.EventCapacity}}</b>
                              </p>
                              <p class="smallerSpace">{{$translate('CAP_FREE_BATCH_CAP')}}<b>{{innerItem.FreeBatchCapacity}}/{{innerItem.BatchCapacity}}</b>
                              </p>
                            </v-layout>
                          </v-flex>
                          <v-flex xs1>
                            <div class="divvie" :style="`background-color: ${setBackgroundColor(innerItem.State)}`">
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-hover>
                  </template>
                </v-card>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
      <div v-else>
        <div class="text-xs-center">
          <v-dialog
            v-model="datePickerDialog"
            width="500"
          >
            <v-card>
              <v-card-title
                class="headline grey lighten-2"
                primary-title
              >
                {{$translate('CHOOSE_DATE')}}
              </v-card-title>
              <v-date-picker
                :allowed-dates="allowedCalendarDates"
                :events="allowedCalendarDates"
                v-model="chosenDate"
                full-width
                no-title
                style="width:100%"
              ></v-date-picker>
              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  round
                  @click="getPlanBoard(chosenEvent)"
                >
                  {{$translate('ORDER')}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <v-layout class="toolBarTwo" align-start justify-start row wrap>
          <v-flex xs6>
            <v-select
              single-line
              v-if="noEvent == false"
              class="compact-form"
              :label="$translate('EVENT')"
              v-model="preEvent"
              :items="eventList"
              item-text="Name"
              return-object
              item-value="EventId"
              @change="openEventIndex"
            ></v-select>
            <v-select
              v-else
              :label="$translate('NO_EVENT_AVAILABLE')"
              :disabled="noEvent == true"
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
              single-line
              v-if="noEvent == false"
              class="compact-form"
              :label="$translate('EVENT_DATE_RANGE')"
              v-model="dateRangeSelection"
              :items="['Today','7 days ahead',' 1 month ahead', 'Free choice']"
              @change="triggerGetPlanBoard"
            ></v-select>
          </v-flex>
          <v-flex v-if="preEvent.Type === 'OrderEvent'" xs6>
            <v-select
              single-line
              v-if="noEvent == false"
              class="compact-form"
              :label="$translate('CHOOSE_AN_OPTION')"
              v-model="deliveryOrTakeAway"
              :items="['Delivery','TakeAway']"
              @change="triggerGetPlanBoard"
            ></v-select>
          </v-flex>
          <v-flex class="bottomRow" v-if="preEvent.Type === 'Rental'" xs6>
            <v-select
              single-line
              v-if="noEvent == false"
              class="compact-form"
              :label="$translate('EVENT_PRODUCT')"
              v-model="eventOrProducts"
              :items="['Event','Products']"
              @change="triggerGetProducts"
            ></v-select>
          </v-flex>
          <v-flex class="bottomRow" v-if="preEvent.Type === 'Rental' && eventOrProducts === 'Products'" xs6>
            <v-select
              single-line
              v-if="noEvent == false"
              class="compact-form"
              :label="$translate('EVENT_MESSAGE_SELECT_PRODUCT')"
              item-value="Id"
              item-text="Name"
              v-model="selectedProduct"
              :items="products"
              @change="triggerGetPlanBoard"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-card class="responseDataLarge">
          <v-flex xs12 v-if="emptyPlanboard">
            <v-layout align-space-around justify-space-around row fill-height>
              <v-icon justify-space-around disabled color="primary" style="font-size: 100px;">ballot</v-icon>
            </v-layout>
          </v-flex>
          <v-layout v-else justify-center>
            <v-flex xs10 d-flex>
              <v-card class="scrollbarCalendarLarge elevation-0 transparent">
                <v-card v-for="(item, index) of planBoard.PlanBoard" :key="index">
                  <v-layout justify-center row wrap>
                    <v-card class="elevation-0 transparent calendarDate">
                      <h3 class="pa-1">{{item.Date}}</h3>
                    </v-card>
                  </v-layout>
                  <v-card @click="triggerSlotMessage(innerItem)" style="text-align:left" v-for="(innerItem, innerIndex) of item.TimeSlots" color="grey lighten-2" :key="innerIndex" class="timeslotsCards">
                    <v-layout style="text-align:left" row>
                      <v-layout row>
                        <v-flex xs3>
                          <v-card class="elevation-0 transparent">
                            <h3 v-if="innerItem.hasOwnProperty('Type')">{{innerItem.Time}} ({{innerItem.Type}})</h3>
                            <h3 v-else>{{innerItem.Time}}</h3>

                          </v-card>
                        </v-flex>
                        <v-flex xs8>
                          <v-layout justify-left align-left row>
                            <p class="smallerSpace">{{$translate('CAP_FREE_EVENT_CAP')}} <b>{{innerItem.FreeEventCapacity}}/{{planBoard.EventCapacity}}</b></p>
                            <p class="ml-4 smallerSpace">{{$translate('CAP_FREE_BATCH_CAP')}}<b>{{innerItem.FreeBatchCapacity}}/{{innerItem.BatchCapacity}}</b></p>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1>
                          <div class="divvie" :style="`background-color: ${setBackgroundColor(innerItem.State)}`">
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-card>
                </v-card>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
    </v-card>
    <v-dialog v-model="messageDialog" max-width="320" persistent content-class="dialog_class">
      <v-card>
        <v-card-title class="headline">{{$translate('SEND_MSG_TO_TS')}} {{newMessage.Time}} {{$translate('ON_THE')}} {{newMessage.Date}}</v-card-title>
        <v-card-text>
          <h3>
            {{$translate('ENTER_TITLE_MSG')}}
            <br />
          </h3>
          <v-text-field
            outline
            input="text"
            v-model="newMessage.Title"
            :label="$translate('ENTER_TITLE_MSG')"
          ></v-text-field>
          <h3>
            {{$translate('ENTER_TEXT_MSG')}}
            <br />
          </h3>
          <v-textarea
            outline
            :label="$translate('ENTER_TEXT_MSG')"
            clearable
            auto-grow
            v-model="newMessage.Text"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            round
            @click="closeMessageDialog"
          >{{$translate('CANCEL')}}</v-btn>
          <v-btn
            color="primary"
            class="text-capitalize"
            round
            @click="warningDialog = true"
          >{{$translate('SEND')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warningDialog" max-width="400" persistent content-class="dialog_class">
      <v-card>
        <v-card-title class="headline">{{$translate('WARNING')}}</v-card-title>
        <v-card-text>
          <h3>
            {{$translate('SEND_MSG_TO_TS_CHECK')}}  {{newMessage.Time}} {{$translate('ON_THE')}} {{newMessage.Date}} ?
            <br />
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            round
            @click="warningDialog = false"
          >{{$translate('NO')}}</v-btn>
          <v-btn
            color="primary"
            class="text-capitalize"
            round
            @click="sendMessageBySlot"
          >{{$translate('YES_SEND_MSG')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import "chartjs-plugin-zoom";
  import OperationalScreen_BaseQuadrant from "./OperationalScreen_BaseQuadrant";
  import OperationalScreen_QuadrantToolbar from "./OperationalScreen_QuadrantToolbar";
  import BatchObject from "../../objects/BatchObject.js";
  import * as dssRequest from "../../api/dssRequest";
  import appConfig from "../../../config/app_config";
  export default {
    name: "OperationalScreen_EventQuadrant",
    extends: OperationalScreen_BaseQuadrant,
    props: {
      boxConfig: {}
      //eventId: String
      // objId: String
    },
    computed: {

    },
    components: {
      OperationalScreen_QuadrantToolbar,
    },
    // computed: {
    //   parseDayOnClick: function () {
    //     return this.currentDay.toLocaleDateString().split("/").join("-")
    //   }
    // },
    watch: {
    },
    data() {
      return {
        warningDialog: false,
        calendarList: [],
        newMessage: {},
        messageDialog: false,
        selectedProduct: {},
        products: [],
        planBoardRepetitive: {},
        eventOrProducts: '',
        deliveryOrTakeAway: '',
        dateRangeSelection: '',
        chosenEvent: '',
        eventId: "",
        eventList: [],
        noEvent: false,
        preEvent: "",
        planBoard: {},
        emptyPlanboard: true,

        //datepicker
        datePickerDialog: false,
        chosenDate: '',
      };
    },
    created() {
      this.headers = ["EVENT_TITLE"];
      // this.createMockData();
    },
    beforeDestroy() {
    },
    mounted() {
      this.dateRangeSelection = '7 days ahead';
      if (this.preEvent.Type === 'Rental') {
        this.eventOrProducts = 'Event';
      }
      this.locationId = this.properties.signalObjectMap.entries().next().value[0];
      this.planBoardRepetitive = setInterval(this.triggerGetPlanBoard, 30000);
      if (this.$store.getters.getQuadrantEvent.hasOwnProperty("EventId")) {
        this.openEventIndex(this.$store.getters.getQuadrantEvent);
        this.preEvent = this.$store.getters.getQuadrantEvent;
      } else {
      }
      this.getEventsBasedOnUserLevel(this.locationId);
    },
    methods: {

      getStartDates(){
        const toTwoDigits = num => (num < 10 ? "0" + num : num);
        let today = new Date();
        let year = today.getFullYear();
        let month = toTwoDigits(today.getMonth() + 1);
        let day = toTwoDigits(today.getDate());
        let todayDate = day + "-" + month + "-" + year;
        let payload = {
          OrderType: this.deliveryOrTakeAway,
          StartDate: todayDate,
        };
        this.calendarList = [];
        dssRequest.doRequest(
          response => {
            console.log("the call for getStartDates was successful", response);
            this.allowedStartDate = []
            for(let [index, item] of Object.entries(response.data.Calendar)){
              const [day, month, year] = index.split("-");
              index = `${year}-${month}-${day}`;
              this.calendarList.push(index)
            }
          },
          error => {
            console.log("the call for getStartDates was not successful", error);
          },
          "getStartDates",
          this.preEvent.EventId,
          payload
        );
      },
      allowedCalendarDates(val) {
        return this.calendarList.indexOf(val) !== -1;
      },
      closeMessageDialog() {
        this.newMessage = {};
        this.messageDialog = false;
      },
      sendMessageBySlot() {
        if (this.warningDialog === true) {
          this.warningDialog = false;
        }
        let payload = {
          EventId: this.preEvent.EventId,
          TimeSlots: {
            0: {
              StartTime: this.newMessage.Time,
              StartDate: this.newMessage.Date
            },
          },
          Title: this.newMessage.Title,
          Text: this.newMessage.Text
        };
        dssRequest.doRequest(
          response => {
            console.log("The generic call sendMessageBySlot was successful", response);
            this.newMessage = {};
            this.messageDialog = false;
          },
          error => {
            console.log(
              "The generic call sendMessageBySlot was not successful",
              error
            );
          },
          "sendMessageBySlot",
          this.$store.getters.getCurrentAccountId + "_CMR",
          payload
        );
      },
      triggerSlotMessage(slot) {
        this.newMessage = {};
        this.messageDialog = true;
        this.newMessage = slot;
        this.newMessage.Title = "";
        this.newMessage.Text = "";
      },
      triggerGetProducts() {
        if (this.eventOrProducts === 'Event') {
          this.triggerGetPlanBoard();
        } else {
          let payload = {};
          dssRequest.doRequest(
            response => {
              console.log("The generic call getProducts was successful", response);
              delete response.data.ErrorMsg;
              this.products = Object.values(response.data.Products);
              this.selectedProduct = this.products[0];
              this.triggerGetPlanBoard();
            },
            error => {
              console.log(
                "The generic call getProducts was not successful",
                error
              );
              // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
            },
            "getProducts",
            this.preEvent.EventId,
            payload
          );
        }
      },
      triggerGetPlanBoard() {
        if (this.preEvent.Type === 'Rental' && this.eventOrProducts === 'Products') {
          if (this.dateRangeSelection === 'Today') {
            this.getProductPlanBoard(this.chosenEvent, this.getCurrentDate())
          } else if (this.dateRangeSelection === '7 days ahead') {
            this.getProductPlanBoard(this.chosenEvent, this.getNextWeekFromToday())
          } else if(this.dateRangeSelection === 'Free choice'){
            this.getStartDates();
            this.datePickerDialog = true;
          }else {
            this.getProductPlanBoard(this.chosenEvent, this.getNextMonthFromToday())
          }
        } else {
          if (this.dateRangeSelection === 'Today') {
            this.getPlanBoard(this.chosenEvent, this.getCurrentDate())
          } else if (this.dateRangeSelection === '7 days ahead') {
            this.getPlanBoard(this.chosenEvent, this.getNextWeekFromToday())
          } else if(this.dateRangeSelection === 'Free choice'){
            this.getStartDates();
            this.datePickerDialog = true;
          }else {
            this.getPlanBoard(this.chosenEvent, this.getNextMonthFromToday())
          }
        }
      },
      getEventsBasedOnUserLevel(locationId = null) {
        let payload = {
          FunctionId: "EventFunctionLibrary::getEventsBasedOnUserLevel",
          UserLevel: this.$store.getters["auth/userLevel"],
          PartnerId: this.$store.getters["auth/partnerId"],
          Filters: {
            LocationId: "",
            Tags: {},
            Type: {},
            Name: this.$store.getters.getEventFilterName
          }
        };
        if (locationId !== null) {
          payload.Filters.LocationId = locationId;
        }
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call getEventsBasedOnUserLevel was successful",
              response
            );
            this.eventList = BatchObject._createArrayWithObjects(
              response.data.Events
            );

            if (this.eventList.length > 0) {
              this.noEvent = false;
              if (!this.$store.getters.getQuadrantEvent.hasOwnProperty("EventId")) {
                this.preEvent = this.eventList[0];
                if (this.preEvent.Type === 'OrderEvent') {
                  this.deliveryOrTakeAway = 'Delivery';
                }
                this.$store.commit("setQuadrantEvent", this.preEvent);
              }

              this.openEventIndex(this.preEvent);
            } else {
              this.noEvent = true;
            }
          },
          error => {
            console.log(
              "The generic call getEventsBasedOnUserLevel was not successful",
              error
            );
            this.noEvent = true;
            // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
          },
          "communicateWithDBLibrary",
          this.currentAccountId,
          payload
        );
      },
      openEventIndex(o) {
        this.$store.commit("setQuadrantEvent", o);
        if (o.Type === 'OrderEvent') {
          this.deliveryOrTakeAway = 'Delivery';
        }
        if (o.Type === 'Rental') {
          this.eventOrProducts = 'Event';
        }
        let index = this.eventList.findIndex(elem => elem.EventId == o.EventId);
        if (index !== -1) {
          this.getPlanBoard(o.EventId, this.getNextWeekFromToday());
          this.chosenEvent = o.EventId;
        } else {
        }
      },
      getPlanBoard(eventId, preferredEndDate) {
        console.log("Laurens this.properties", this.properties);

        // This function is used to get all batches (time-slots) of an event, to show how busy it is between a certain start/end date
        var d = new Date(); // for now
        let x = d.getHours(); // => 9
        let y = d.getMinutes(); // =>  30
        let n = x + ":" + y;

        let payload = {};
        if(this.datePickerDialog){
          let today = this.chosenDate
          const [year, month, day] = today.split("-");
          today = `${day}-${month}-${year}`;
          payload = {
            StartTime: String(n),
            EndTime: "00:00",
            StartDate: today,
            EndDate: today,
            LocationId: this.locationId,
          }
          if(this.preEvent.Type == 'OrderEvent')payload.OrderType = this.deliveryOrTakeAway;
          this.datePickerDialog = false;
        }
        else if (this.preEvent.Type === 'OrderEvent') {
          payload = {
            StartTime: String(n),
            EndTime: "00:00",
            StartDate: this.getCurrentDate(),
            EndDate: preferredEndDate,
            OrderType: this.deliveryOrTakeAway,
            LocationId: this.locationId,
          }
        } else {
          payload = {
            StartTime: String(n),
            EndTime: "00:00",
            StartDate: this.getCurrentDate(),
            EndDate: preferredEndDate,
            LocationId: this.locationId,
          };
        }

        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call getPlanBoard was successful",
              response
            );
            this.planBoard = response.data;
            if(!_.isEmpty(this.planBoard.PlanBoard)) this.emptyPlanboard = false;
            else this.emptyPlanboard = true;
          },
          error => {
            console.log(
              "The generic call getPlanBoard was not successful",
              error
            );
          },
          "getPlanBoard",
          eventId,
          payload
        );
      },
      getProductPlanBoard(eventId, preferredEndDate) {
        // This function is used to get all batches (time-slots) of an product, to show how busy it is between a certain start/end date
        var d = new Date(); // for now
        let x = d.getHours(); // => 9
        let y = d.getMinutes(); // =>  30
        let n = x + ":" + y;

        let payload = {};
        if (!this.selectedProduct.hasOwnProperty("Id")) {
          payload = {
            StartTime: String(n),
            EndTime: "00:00",
            ProductId: this.selectedProduct,
            StartDate: this.getCurrentDate(),
            EndDate: preferredEndDate
          }
        } else {
          payload = {
            StartTime: String(n),
            EndTime: "00:00",
            ProductId: this.selectedProduct.Id,
            StartDate: this.getCurrentDate(),
            EndDate: preferredEndDate
          };
        }
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call getProductPlanBoard was successful",
              response
            );
            this.planBoard = response.data;
          },
          error => {
            console.log(
              "The generic call getProductPlanBoard was not successful",
              error
            );
          },
          "getProductPlanBoard",
          eventId,
          payload
        );
      },
      formatDate(date) {
        if (!date) return null;

        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      },
      setBackgroundColor(item) {
        switch (item) {
          //blue
          case 0:
            return "rgba(25, 181, 254, 1)";
          //green
          case 1:
            return "rgba(0, 230, 64, 0.8)";
          //yellow
          case 2:
            return "rgba(240, 255, 0, 0.8)";
          //red
          case 3:
            return "rgba(240, 52, 52, 0.8)";
        }
      },
      getCurrentDate() {
        //this function is called to get the current day to call the function getCalendar()
        const toTwoDigits = num => (num < 10 ? "0" + num : num);
        let today = new Date();

        let year = today.getFullYear();
        let month = toTwoDigits(today.getMonth() + 1);
        let day = toTwoDigits(today.getDate());
        return day + "-" + month + "-" + year;
      },
      getNextWeekFromToday() {
        // This function is called to return the week after today for getCalendar
        const toTwoDigits = num => (num < 10 ? "0" + num : num);
        let today = new Date();
        today.setDate(today.getDate() + 7);
        let year = today.getFullYear();
        let month = toTwoDigits(today.getMonth() + 1);
        let day = toTwoDigits(today.getDate());
        return day + "-" + month + "-" + year;
      },
      getNextMonthFromToday() {
        // This function is called to return the week after today for getCalendar
        const toTwoDigits = num => (num < 10 ? "0" + num : num);
        let today = new Date();
        today.setDate(today.getDate() + 30);
        let year = today.getFullYear();
        let month = toTwoDigits(today.getMonth() + 1);
        let day = toTwoDigits(today.getDate());
        return day + "-" + month + "-" + year;
      },
    }
  };
</script>
<style lang="scss" scoped="">

  .white {
    color: white;
    padding-left: 0 !important;
  }

  .toolBarTwo {
    margin-left: 0.01em !important;
    max-width: 99.8%;
  }

  .compact-form {
    transform: scale(0.775);
    /*transform-origin: left;*/
    width: 100%;
  }

  .responseData {
    padding: 0.5em;
    min-height: calc(26.5vh);
  }

  .responseDataLarge {
    padding: 0.5em;
    min-height: calc(60vh);
  }

  .scrollbarCalendar {
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(27vh);
  }

  .scrollbarCalendarLarge {
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(57vh);
  }

  .timeslotsCards {
    min-height: calc(4vh);
    padding: 1em;
    margin-bottom: 0.5em;
    cursor: pointer;
  }

  .timeslotsCards:hover {
    background-color: white;

  }

  .smallerSpace {
    margin-bottom: 0.1em;
  }

  .divvie {
    margin-top: calc(1vh);
    height: 1.5em;
    width: 1.5em;
    border-radius: 50%;
    border: 1px solid black;
  }

  .bottomRow {
    margin-top: -2em !important;
  }
</style>
